import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Button, Stack} from 'views/components';
import {CancelOutlined, ChangeCircleOutlined, DeleteOutline, RemoveCircleOutline} from 'views/icons';
import {Translate, useNavigate} from 'views/module';

import TimelineCard from './TimelineCard';
import DeactivationDetails from './DeactivationDetails';
import {formatEventDateTime} from '../dateTime';

// One card per deactivation action. INACTIVE covers legacy records that carry no action.
const ACTION_DISPLAY = {
  CANCELLED: {icon: CancelOutlined, iconColor: '#b03621', langKey: 'ShiftCancelled'},
  DELETED: {icon: DeleteOutline, iconColor: '#424242', langKey: 'ShiftDeleted'},
  RESCHEDULED: {icon: ChangeCircleOutlined, iconColor: '#cf8842', langKey: 'ShiftRescheduled'},
  INACTIVE: {icon: RemoveCircleOutline, iconColor: '#616161', langKey: 'ShiftInactive'},
};

const ShiftDeactivated = (props) => {
  const {deactivatedData, eventTimezone, changedByLabel, action} = props;

  const navigate = useNavigate();

  const display = ACTION_DISPLAY[action];
  const timeString = formatEventDateTime(deactivatedData.timeDeactivated, eventTimezone);
  const newEventRn = deactivatedData.newRescheduleEventRn;

  return (
    <Box>
      <TimelineCard
        timeString={timeString}
        icon={display.icon}
        iconColor={display.iconColor}
        timeBg="#e0e0e0"
        title={<Translate expression={`schedule.eventDetail.EventTimelineSection.${display.langKey}.DeactivatedTitle`} />}
      >
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            <Translate expression={`schedule.eventDetail.EventTimelineSection.${display.langKey}.DeactivatedDescription`} />
          </Typography>
          <DeactivationDetails
            deactivatedData={deactivatedData}
            changedByLabel={changedByLabel}
          />
          {
            newEventRn &&
            <Button
              variant="outlined"
              size="small"
              onClick={() => navigate(`/schedule/event/${newEventRn}`)}
              sx={{width: 'fit-content'}}
            >
              <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRescheduled.ViewNewEvent' />
            </Button>
          }
        </Stack>
      </TimelineCard>
    </Box>
  );
};

ShiftDeactivated.propTypes = {
  deactivatedData: PropTypes.shape({
    action: PropTypes.oneOf(['CANCELLED', 'DELETED', 'RESCHEDULED']),
    changedByRn: PropTypes.string,
    description: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
    timeDeactivated: PropTypes.string,
    newRescheduleEventRn: PropTypes.string,
  }),
  eventTimezone: PropTypes.string.isRequired,
  changedByLabel: PropTypes.string,
  action: PropTypes.oneOf(Object.keys(ACTION_DISPLAY)).isRequired,
};

export default ShiftDeactivated;
